export default __webpack_public_path__ + "e33a3bfe5f09e49b2a518d4290de81d0.png";